'use client';

import {useRouter} from 'next/navigation';
import {useCallback} from 'react';

import {AppsWithPagination} from '@web-catalog/components/AppsWithPagination';

import {AppsResponse, AppType} from '@web-catalog/types';

import {removeDuplicatedSlashes, removeTrailingSlash} from '@web-catalog/utils';

import styles from './CategoryAppsList.module.scss';

export type Props = {
  appsResponse: AppsResponse;
  listName: string;
  page: number;
  appType: AppType;
  category: string;
};

export const CategoryAppsList = ({
  listName,
  appsResponse,
  page,
  appType,
  category,
}: Props) => {
  const router = useRouter();
  const onPageChange = useCallback(
    (page: number) => {
      const url = removeTrailingSlash(
        removeDuplicatedSlashes(
          [
            appType === AppType.GAMES ? '/games' : '/',
            category,
            page > 1 ? `page-${page}` : '',
          ]
            .filter(Boolean)
            .join('/'),
        ),
      );
      router.push(url);
    },
    [appType, category, router],
  );

  return (
    <AppsWithPagination
      appsResponse={appsResponse}
      pageNumber={page}
      listName={listName}
      onPageChange={onPageChange}
      prefetch={false}
      className={styles.root}
      allowAds
    />
  );
};
